export function cleanWordPasteHtml(html: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  for (const el of doc.querySelectorAll('*')) {
    if (el.hasAttribute('lang')) {
      el.removeAttribute('lang');
    }

    for (const className of Array.from(el.classList)) {
      if (className.startsWith('Mso')) {
        el.classList.remove(className);
      }
    }

    if (el.classList.length === 0) {
      el.removeAttribute('class');
    }

    const rawStyle = el.getAttribute('style');
    if (rawStyle) {
      const newStyle = rawStyle
        .split(';')
        .map((s) => s.trim())
        .filter((s) => s && !s.startsWith('mso-') && !s.startsWith('font-'))
        .join('; ');

      if (newStyle) {
        el.setAttribute('style', newStyle);
      } else {
        el.removeAttribute('style');
      }
    }
  }

  return doc.body.innerHTML;
}
